module.exports = __webpack_public_path__ + "img/file-shield-03.16dc3a62.svg";